import React, { Component } from 'react'
import { connect } from 'react-redux'
// import moment from 'moment'

// Utils
import { hasAccess, hasSubscriptionPermission, hasPartnerSubscriptionPermission } from '../../../../../utils/auth'
import { renderFullDate } from '../../../../../utils/time'
import CreateEstimationModal from '../../../../../shared/modals/CreateEstimationModal'

// Constants
import { FILE_STORAGE_API } from '../../../../../constants'

// components
import InfoPopup from '../../../../../shared/components/InfoPopup'
import Portal from '../../../../../shared/components/Portal'

// Utils
import { translation } from '../../../../../utils/helpers'
import { triggerPopup, triggerPopupActionBG } from '../../../../../actions/backdrop'

const DEPARTMENTTYPE = {
  Paint: 0,
  Body: 1
}

class Taksering extends Component {

  constructor (props) {
    super(props)
    this.state = {
      showInfoPopup: false,
      estimation: {
        open: false
      }
    }
    this.openLink = this.openLink.bind(this)
  }

  openLink (link, allowClick) {
    if (!allowClick) return
    this.props.router.push(link)
  }

  changeIcon (icon) {
    if (this.props.type === 'workscreen' && this.props.item.IsStarted) icon = icon.replace('.svg', '-white.svg')
    return icon
  }

  formatSectionType (sectionType) {
    switch (sectionType) {
      case 1:
        return DEPARTMENTTYPE.Paint
      case 2:
        return DEPARTMENTTYPE.Body
      default:
        break
    }
  }

  render () {
    let allowClick = this.props.type !== 'workscreen'
    let image = ''
    let isMainReportLoadedIcon = false
    let report = this.props.item.Report
    let attachment = null
    if (report !== null) {
      attachment = report.Attachments.find(item => this.formatSectionType(item.SectionType) === this.props.auth.departmentType)
    }

    const clickPriceApproval = (e) => {
      if (this.props.auth.departmentType === 1 && hasAccess([4], this.props.auth.user.UserType)) return null
      if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
      let orderPriceType = e.target.name.split('.')[1]
      let token = orderPriceType === 'Extent' ? this.props.item.PriceApprovalToken : this.props.item.PriceApprovalTokenAddon
      this.openLink('/priceapproval/' + token, allowClick)
    }
    let newFileUrl = ''
    let bookingStopped = this.props.item.IsAgreementForsiCreated && !this.props.item.IsEvaluation
    let evaluationStopped = this.props.item.IsEvaluation && !this.props.item.IsEvaluated && this.props.item.CustomerWPEvaluationRequired && this.props.item.IsAgreementOrder

    if (this.props.item.NeedReferredApprove && allowClick) {
      const onClick = e => {
        if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
        this.props.openReferenceApprove(e)
      }
      return (
        <span className='icon hint--left' aria-label={translation('751')}>
          <img src='/images/svgs/New-order-red-referred.svg' className='hasCursor' onClick={onClick.bind(this)} />
        </span>
      )
    } else if (this.props.item.OrderType === 1 && !this.props.item.PriceApprovalTokenAddon) {
      let { IsAssessmentOk } = this.props.item
      let chainUsesDBS = this.props.auth.permissions.ChainAssessmentSystem === 2
      let mouseText = translation('13023')

      // ### New
      if (report !== null && report.ReportVersionNr === 0 && report.IsApproved) {
        isMainReportLoadedIcon = true
        image = 'main-report-loaded.svg'
        if (report.Paint && attachment) {
          newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
        }
        if (report.Body && attachment) {
          newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
        }
      }

      // if (this.props.item.ForsiOrderExtent) {
      //   isMainReportLoadedIcon = true
      //   image = 'main-report-loaded.svg'
      //   newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + this.props.item..OrderFile.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      // }
      // if (this.props.item.BodyShop) {
      //   isMainReportLoadedIcon = true
      //   image = 'main-report-loaded.svg'
      //   newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + this.props.item.BodyShop.OrderFile.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
      // }
      // if (this.props.item.Id + '' === '130398') { // 130398 doesn't exit
      //   // console.log(this.props.item)
      // }

      const onClickForShop = () => {
        // if (!allowClick || IsAssessmentOk) return
        if (hasAccess([4], this.props.auth.user.UserType) || this.props.auth.departmentType === 1) {
          this.props.router.push('/orders/' + this.props.item.Id + '?page=2')
        } else {
          if (!hasSubscriptionPermission(this.props.auth, 10)) return null
          this.props.router.push('/orders/' + this.props.item.Id + '/orderinspection')
        }
      }
      // Kunde
      if (hasAccess([4], this.props.auth.user.UserType) && this.props.item.LastUpdatedType === 1) {
        image = 'charged-later-recieved.svg'
        isMainReportLoadedIcon = false
        mouseText = translation('1019')
        image = this.changeIcon(image)
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={mouseText}>
              <img src={'/images/svgs/taksering/' + image} className='hasCursor' onClick={onClickForShop} />
            </div>
          </span>
        )
      }

      // Pladev�rksted/Karosseri
      if (!hasAccess([4], this.props.auth.user.UserType) && this.props.item.LastUpdatedType === 1 && this.props.auth.departmentType === 1) {
        image = 'charged-later-recieved.svg'
        isMainReportLoadedIcon = false
        mouseText = translation('1019')
        image = this.changeIcon(image)
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={mouseText}>
              <img src={'/images/svgs/taksering/' + image} className='hasCursor' onClick={onClickForShop} />
            </div>
          </span>
        )
      }

      // Lak/Integration
      if (!hasAccess([4], this.props.auth.user.UserType) && this.props.item.LastUpdatedType === 1 && this.props.auth.departmentType !== 1) {
        image = 'charged-later-sent.svg'
        isMainReportLoadedIcon = false
        mouseText = translation('13528')
        image = this.changeIcon(image)
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={mouseText}>
              <img src={'/images/svgs/taksering/' + image} className='hasCursor' onClick={onClickForShop} />
            </div>
          </span>
        )
      }

      // Additional report = V-Nr > 0 / Minus Rp raport || IsApproved
      // let reportId = this.props.item.ForsiReportId
      // let hasAddonReport = reportId !== null && reportId.substring(reportId.length - 2, reportId.length - 1) === 'T'

      // (hasAddonReport && this.props.item. !== null)
      if (report !== null && !chainUsesDBS && report.IsApproved && report.ReportVersionNr > 0) {
        mouseText = translation('937')
        if (IsAssessmentOk || hasAccess([4], this.props.auth.user.UserType)) {
          image = 'update-approved.svg'
          isMainReportLoadedIcon = false
          if (report.Paint && attachment) {
            // console.log('orderfile', this.props.item..OrderFile)
            newFileUrl = FILE_STORAGE_API + '/FileService/DownloadNoHeader?fileName=' + attachment.FileNameWithFolders + '&token=' + encodeURIComponent(this.props.auth.user.Token)
          }
          if (!hasAccess([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
            mouseText = translation('13530')
          }
          image = this.changeIcon(image)
          return (
            <span className='icon hasTextInBubble'>
              <div className='hint--top' aria-label={mouseText}>
                <a href={newFileUrl} title={attachment ? attachment.FileName : ''} target='_blank'>
                  <img src={'/images/svgs/taksering/' + image} className='hasCursor' />
                </a>
              </div>
            </span>
          )
        } else {
          image = 'update-not-approved.svg'
          isMainReportLoadedIcon = false
          mouseText = translation('13531')
          mouseText = mouseText.replace('- ', '-\n')
          image = this.changeIcon(image)
          return (
            <span className='icon hasTextInBubble'>
              <div className='hint--top' aria-label={mouseText}>
                <img src={'/images/svgs/taksering/' + image} className='hasCursor' onClick={onClickForShop} />
              </div>
            </span>
          )
        }
      }

      // Main report // V-Nr = 0 - Minus Rp Report
      if (hasAccess([4], this.props.auth.user.UserType) && isMainReportLoadedIcon && report.Paint !== null && !chainUsesDBS) {
        image = this.changeIcon(image)
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={mouseText}>
              <a href={newFileUrl} title={attachment ? attachment.FileName : ''} target='_blank'>
                <img src={'/images/svgs/taksering/' + image} className='hasCursor' />
              </a>
            </div>
          </span>
        )
      }

      if (this.props.item.ForsiReportId) {
        if (!hasAccess([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
          if (IsAssessmentOk === true) {
            image = 'main-report-approved.svg'
            isMainReportLoadedIcon = false
            mouseText = translation('13513')
          } else {
            image = 'main-report-not-approved.svg'
            isMainReportLoadedIcon = false
            mouseText = translation('13526')
          }
          mouseText = mouseText.replace('- ', '-\n')
        }
        image = this.changeIcon(image)
        if ((!this.props.item.IsEvaluationRejected || this.props.item.IsEvaluationRejected && !isMainReportLoadedIcon) && !bookingStopped && !evaluationStopped) {
          return (
            <span className='icon'>
              <div className='hint--top' aria-label={mouseText}>
                <img src={'/images/svgs/taksering/' + image} className='hasCursor' onClick={onClickForShop} />
              </div>
            </span>
          )
        }
      }
    } else if (this.props.item.PriceApprovalToken !== null) { // Awaiting price approval?
      // Not insurance orders
      let image = 'price-change-sent.svg'
      let message = 2716

      if (hasAccess([4], this.props.auth.user.UserType)) {
        image = 'price-change-recieved.svg'
        message = 2717
      }

      if (!hasAccess([4], this.props.auth.user.UserType) && this.props.auth.departmentType === 1) {
        image = 'price-change-recieved.svg'
        message = 2717
      }

      image = this.changeIcon(image)
      let iswp = hasAccess([6], this.props.auth.user.UserType)
      if (iswp && this.props.auth.departmentType !== 1) {
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={translation(message)}>
              <img src={'/images/svgs/taksering/' + image} />
            </div>
          </span>
        )
      } else {
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={translation(message)}>
              <img src={'/images/svgs/taksering/' + image} className='hasCursor' name='PriceChange.Extent' onClick={clickPriceApproval.bind(this)} />
            </div>
          </span>
        )
      }
    } else if (this.props.item.PriceApprovalTokenAddon !== null) { // Awaiting addon price approval
      // Set image and text as viewed by shop
      let image = 'price-change-sent.svg'
      let message = 2716

      if (hasAccess([4], this.props.auth.user.UserType)) {
        // Set image and text as viewed by customer
        image = 'price-change-recieved.svg'
        message = 2717
      }

      let iswp = hasAccess([6], this.props.auth.user.UserType)
      if (iswp && this.props.auth.departmentType !== 1) {
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={translation(message)}>
              <img src={'/images/svgs/taksering/' + image} />
            </div>
          </span>
        )
      } else {
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={translation(message)}>
              <img src={'/images/svgs/taksering/' + image} className='hasCursor' name='PriceChange.Addon' onClick={clickPriceApproval.bind(this)} />
            </div>
          </span>
        )
      }
    } else if (this.props.item.LatestPriceApprovalState !== 0) {
      let image = ''
      let message = ''
      if (hasAccess([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 3) {
        message = 2718
      } else if (hasAccess([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 4) {
        message = 2719
      } else if (!hasAccess([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 3 && this.props.auth.departmentType === 1) {
        message = 2718
      } else if (!hasAccess([4], this.props.auth.user.UserType) && this.props.item.LatestPriceApprovalState === 4 && this.props.auth.departmentType === 1) {
        message = 2719
      } else if (this.props.item.LatestPriceApprovalState === 3) {
        message = 2714
      } else {
        message = 2715
      }

      switch (this.props.item.LatestPriceApprovalState) {
        case hasAccess([4], this.props.auth.user.UserType):
        case 3: // approved
          image = 'price-change-approved.svg'
          break
        case 4: // rejected
          image = 'price-change-rejected.svg'
          break
      }

      image = this.changeIcon(image)
      return (
        <span className='icon'>
          <div className='hint--left' aria-label={translation(message)}>
            <img src={'/images/svgs/taksering/' + image} />
          </div>
        </span>
      )
    }

    // Evaluation
    if ((hasSubscriptionPermission(this.props.auth, 30) || hasSubscriptionPermission(this.props.auth, 0) && hasPartnerSubscriptionPermission(this.props.auth, 30)) && (this.props.item.IsEvaluation || bookingStopped || evaluationStopped)) {
      let image
      let text
      let classes = ''
      const renderNewEvaluation = () => {
        if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
        this.props.triggerPopup(true)
        this.setState({
          estimation: {
            open: true
          }
        })
      }
      const closeEstimation = () => {
        this.setState({
          estimation: {
            open: false
          }
        })
        this.props.triggerPopup(false)
        // this.props.updateOrder(this.props.item)
      }
      // console.log('item', this.props.item)
      if (this.props.item.IsEvaluationRejected || bookingStopped || evaluationStopped) {
        text = translation('13715')
        // console.log('[Taksering] item', this.props.item)
        let imagePath = '/images/svgs/taksering/damage-assessment.svg'
        if (hasAccess([3, 4, 5, 7], this.props.auth.user.UserType)) {
          imagePath = '/images/svgs/taksering/additional-support-added.svg'
        }
        if (this.props.auth.departmentType === 1) {
          imagePath = '/images/svgs/taksering/additional-support-added.svg'
        }
        if (bookingStopped || evaluationStopped) {
          text = translation('15177')
        }
        image = this.changeIcon(imagePath)
        return (
          <span className='icon'>
            <div className='hint--left' aria-label={text}>
              <img src={image} className='hasCursor' onClick={renderNewEvaluation.bind(this)} />
              {this.state.estimation.open && (
                <CreateEstimationModal router={this.props.router}
                  show={this.state.estimation.open}
                  id={this.props.item.Id}
                  orderId={this.props.item.Id}
                  onClose={closeEstimation.bind(this)}
                  onSave={this.props.updateOrder} />
              )}
            </div>
          </span>
        )
      }

      const onClickForShop = () => {
        if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
        if (!hasAccess([4], this.props.auth.user.UserType)) {
          if (this.props.item.CurrentShopOrWpCanAnswer === true && this.props.auth.departmentType !== 1) {
            this.props.router.push('/pricecalculation/' + this.props.item.Id + '/3')
          } else if (!this.props.item.IsEvaluated && this.props.auth.departmentType !== 1) {
            if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
            this.setState({
              showInfoPopup: true
            })
          }
        } else {
          this.props.router.push('/orders/' + this.props.item.Id + '?page=2')
        }
      }

      const onInfoClick = () => {
        if (typeof this.props.onPopupOpen === 'function') this.props.onPopupOpen()
        this.setState({
          showInfoPopup: false
        })
      }

      if (!hasAccess([4], this.props.auth.user.UserType) && this.props.auth.departmentType !== 1) {
        // Shop
        if (this.props.item.IsEvaluated) {
          if (!this.props.item.CustomerWPEvaluationRequired && this.props.item.IsEvaluation && !this.props.item.CurrentShopOrWpCanAnswer && !hasAccess([6], this.props.auth.user.UserType)) {
            image = this.changeIcon('/images/svgs/taksering/additional-support-added.svg')
          } else {
            image = this.changeIcon('/images/svgs/taksering/damage-assessment.svg')
          }
          text = translation('13400')

          if (hasAccess([6], this.props.auth.user.UserType) && this.props.item.IsEvaluatedDate !== null) {
            text += ' ' + renderFullDate(this.props.item.IsEvaluatedDate)
            text += ' - ' + this.props.item.IsEvaluatedBy
          }
        } else {
          // console.log('[Taksering] item', this.props.item)
          if (!this.props.item.CustomerWPEvaluationRequired && this.props.item.IsEvaluation && !this.props.item.CurrentShopOrWpCanAnswer && !hasAccess([6], this.props.auth.user.UserType)) {
            image = this.changeIcon('/images/svgs/taksering/damage-assessment.svg')
          } else {
            image = this.changeIcon('/images/svgs/taksering/additional-support-added.svg')
          }
          text = translation('13399')
        }
        allowClick = true
        classes = 'hasCursor'
      } else {
        // Customer
        if (this.props.item.IsEvaluated) {
          image = this.changeIcon('/images/svgs/taksering/additional-support-added.svg')
          text = translation('2700')
        } else {
          image = this.changeIcon('/images/svgs/taksering/damage-assessment.svg')
          text = translation('13399')
        }
      }
      const returns = () => {
        return
      }
      return (
        <span className={'icon ' + classes}>
          <div className={this.props.type === 'workscreen' ? 'hint--top' : 'hint--left'} aria-label={text}>
            <img src={image} onClick={onClickForShop} className='hasCursor' />
          </div>
          {this.state.showInfoPopup && (
            <Portal className='confirm_popup' onPortalClose={returns}>
              <InfoPopup t={translation} Hedder={534} Text={translation(14715).replace('[wp]', this.props.item.WorkProviderName)} click={onInfoClick} />
            </Portal>
          )}
        </span>
      )
    }
    return <div className='icon' />
  }

}

function mapStateToProps (state) {
  return {
    auth: state.auth
  }
}

export default connect(mapStateToProps, {
  triggerPopup,
  triggerPopupActionBG
})(Taksering)



// WEBPACK FOOTER //
// ./src/app/pages/Orders/OrderList/NewItem/Taksering/index.js